<template>
  <section class="padd-40">
    <div class="container">
      <div class="row" data-aos="fade-up">
        <div class="col-md-12">
          <div class="heading">
            <h2>认可雇主企业推荐</h2>
          </div>
        </div>
      </div>
      <div class="row ads" ref="scriptHolder">
        <div class="col-md-2 col-sm-4 col-xs-4 padd-5 media-padd">
          <ins data-revive-zoneid="103" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0" data-revive-block="1"></ins>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 padd-5">
          <ins data-revive-zoneid="104" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0" data-revive-block="1"></ins>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 padd-5 media-padd1">
          <ins data-revive-zoneid="105" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0" data-revive-block="1"></ins>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 padd-5 media-padd">
          <ins data-revive-zoneid="106" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0" data-revive-block="1"></ins>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 padd-5">
          <ins data-revive-zoneid="107" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0" data-revive-block="1"></ins>
        </div>
        <div class="col-md-2 col-sm-4 col-xs-4 padd-5 media-padd1">
          <ins data-revive-zoneid="108" data-revive-id="e6dd1ba23f7506ab80d6247cea9b09d0" data-revive-block="1"></ins>
        </div>
      </div>
    </div>
  </section>
</template>
<style>
.ads img {
    max-width: 100%;
    max-height: 100%;
    width:100%;
    height:100%;
    border: 1px solid rgb(221, 221, 221)
}
</style>
<script>
export default {
  name: 'HomeCarousel',
  mounted: function() {
    /*let ads = document.createElement('script')
    ads.type = 'text/javascript'
    ads.src = '/ads/ads.js'
  this.$refs.scriptHolder.appendChild(ads)*/
  var a = 'e6dd1ba23f7506ab80d6247cea9b09d0', c = window.reviveAsync;
  if (c && c.hasOwnProperty(a)) {
    c[a].refresh();
  } 
  }
}
</script>